import { z } from 'zod';
import { isScalar, objectKeysForValue } from '#common/utils/zod.ts';

export const takeTtsModelInfoSchema = // z.union([
    z.object({
        voiceType: z.literal('elevenlabs'),
        textId: z.string(),
        elevenLabsSpeakerVoiceIdId: z.string()
    }); // ,
//     z.object({
//         voiceType: z.literal('custom'),
//         customTtsModelId: z.string()
//     }),
// ]);

export type TakeTtsModelInfo = z.infer<typeof takeTtsModelInfoSchema>;

export const minimalTakeSchema = z.object({
    takeId: z.string()
});

export type MinimalTake = z.infer<typeof minimalTakeSchema>;

export function renderHiddenFieldsFromDiscriminatedUnion<TSchema extends z.ZodTypeAny>(args: {
    schema: TSchema; // object / union / intersection (including nested discriminated unions)
    discriminator: string; // e.g. "voiceType"
    value: z.infer<TSchema>; // compile-time shape
    namePrefix: string; // e.g. `recordings[${i}][takes][${j}]`
}) {
    const { schema, discriminator, value, namePrefix } = args;

    // 1) Validate whole object - silently discard if invalid
    const result = schema.safeParse(value);
    if (!result.success) {
        console.warn('Invalid value for hidden fields, discarding:', result.error.errors);
        return null;
    }
    const parsed = result.data;

    // 2) Derive the relevant keys for the parsed value, respecting unions inside intersections.
    const keys = objectKeysForValue(schema, { discriminator, value: parsed });
    const fallbackKeys = keys.size > 0 || typeof parsed !== 'object' || parsed === null
        ? keys
        : new Set(Object.keys(parsed as Record<string, unknown>));

    return (
        <>
            {[ ...fallbackKeys ].map((k) => {
                const v = (parsed as any)[k];
                if (v === undefined) {
                    return null;
                }
                if (!isScalar(v)) {
                    return null; // extend if you want nested/arrays
                }
                return (
                    <input key={`${namePrefix}[${k}]`} type='hidden' name={`${namePrefix}[${k}]`} value={String(v)} />
                );
            })}
        </>
    );
}
